var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgOwner = function SvgOwner(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.615A3.386 3.386 0 0 0 4.667 5.41v1.257H3.333v-2h.895a4.002 4.002 0 0 1 7.544 0h.895v2h-1.334V5.41A3.386 3.386 0 0 0 8 2.615ZM10.667 6a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Zm2.498 7.333a5.336 5.336 0 0 0-10.33 0c-.11.426-.168.873-.168 1.334h10.666c0-.46-.058-.908-.168-1.334Z",
    fill: "currentColor"
  })));
};
export default SvgOwner;